import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import ChangePasswordForm, { IChangePasswordFormProps } from "../forms/changePasswordForm";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import { getPreLoginData } from "../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface IResetCredsScreenProps extends IChangePasswordFormProps {
	onClose?: () => void;
}

const ResetCredsScreen: React.FC<IResetCredsScreenProps> = ({ onClose, ...props }) => {
	return (
		<LoginPopup centerHeaderContent={<img src={logo} alt="nuvama" className="nuvama_logo"/>} onClose={onClose} className="change_pw_scrn">
			<section className="login_form change_pw_form">
				<div className="header mg-b40">
					<span className="initial ib mg-b30">{getPreLoginData("userID")[0].toUpperCase()}</span>

					<h1 className={"title mg-b15" + (props.submitState ? " submit" : "")}>
						WELCOME {getPreLoginData("userID").split(" ")[0].toUpperCase()}!
					</h1>
					<h2 className="subtitle">Please take a few minutes to update your login credentials for secure experience</h2>
				</div>

				<ChangePasswordForm {...props} />
			</section>
		</LoginPopup>
	);
};

export default ResetCredsScreen;
